import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=a5ba0518&scoped=true"
import script from "./Communication.vue?vue&type=script&lang=js"
export * from "./Communication.vue?vue&type=script&lang=js"
import style0 from "./Communication.vue?vue&type=style&index=0&id=a5ba0518&prod&scoped=true&lang=css"
import style1 from "./Communication.vue?vue&type=style&index=1&id=a5ba0518&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ba0518",
  null
  
)

export default component.exports